import { IconBook, IconUser, IconSchool } from '@tabler/icons-react';

import { SegmentedControl } from '@/components/SegmentedControl';
import { EUserRole } from '@/enum';
import { useFormatText } from '@/hooks/useFormatText';

import { useAuthRole } from './authContext';

const AuthRoleSelector = () => {
  const { role, setRole } = useAuthRole();
  const { formatText } = useFormatText();

  return (
    <div className="w-full">
      <p className="text-sm font-semibold text-neutral-primary mb-2">
        {formatText('auth-layout.select-role')}
      </p>
      <SegmentedControl<EUserRole>
        fullWidth
        value={role}
        onChange={setRole}
        options={[
          {
            value: EUserRole.SCHOOL,
            label: formatText('auth-layout.roles.school'),
            icon: IconSchool,
          },
          {
            value: EUserRole.TEACHER,
            label: formatText('auth-layout.roles.teacher'),
            icon: IconBook,
          },
          {
            value: EUserRole.PARENT,
            label: formatText('auth-layout.roles.parent'),
            icon: IconUser,
          },
        ]}
      />
    </div>
  );
};

export default AuthRoleSelector;
